import type { CustomIconProps } from '../CustomIcon';

export const UserOutlineExecutedIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M19.6666 18.3865V16.7198C19.6666 15.8358 19.3154 14.9879 18.6903 14.3628C18.0652 13.7377 17.2173 13.3865 16.3333 13.3865H9.66659C8.78253 13.3865 7.93468 13.7377 7.30956 14.3628C6.68444 14.9879 6.33325 15.8358 6.33325 16.7198V18.3865'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.0001 10.0531C14.841 10.0531 16.3334 8.56076 16.3334 6.71981C16.3334 4.87886 14.841 3.38647 13.0001 3.38647C11.1591 3.38647 9.66675 4.87886 9.66675 6.71981C9.66675 8.56076 11.1591 10.0531 13.0001 10.0531Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx='6' cy='14.8879' r='6' fill='#0F9F37' stroke='white' strokeWidth='2' />
    <path d='M3 14.3879L5.30769 16.8879L9 12.8879' stroke='white' strokeWidth='1.5' />
  </svg>
);
